/**
 * companyName.js — メール差込 {$company$} 等に使う「代表会社名」の決定（純関数のみ）
 * ------------------------------------------------------------------
 * 「グループ会社・系列会社構造」PJ。サーバー helpers/resolveCompanyName.js と同一規則
 * （変更時は両方を同期すること）。即時メール送信（SurveyMailSendPage）で使用する。
 *
 *   - 系列会社ありグループ（has_affiliates=true）かつ シーズンの company_name_source が 'company'
 *     → User.company（系列会社名）。空ならグループ名へフォールバック
 *   - それ以外 → グループ名。空なら User.company へフォールバック
 *   - いずれも前後空白を除去する
 */

// メール差込 {$company$} 等に使う「代表会社名」。サーバー helpers/resolveCompanyName.js と同一規則。
export const resolveCompanyName = (group, user, season) => {
  const groupName = group && group.group_name ? String(group.group_name).trim() : '';
  const userCompany = user && user.company ? String(user.company).trim() : '';
  const affiliate = !!(group && group.has_affiliates);
  const useCompany = affiliate && season && season.company_name_source === 'company';
  if (useCompany) return userCompany || groupName;
  return groupName || userCompany;
};
